import {InjectionToken} from '@angular/core';

export const TISA_CURRENT_LOCALE = new InjectionToken<() => string>(
  'Provides current locale to be used as url prefix.',
);
